import en from './en'
import fr from './fr'
import de from './de'
import es from './es'
import pt from './pt'
import zh from './zh'
import hi from './hi'
import ja from './ja'
import ru from './ru'

export default {
  en,
  fr,
  de,
  es,
  pt,
  zh,
  hi,
  ja,
  ru
}



// WEBPACK FOOTER //
// ./src/lang/messages.js